import {Fragment} from "preact";
import s from "./heading.module.css";
import { useAppContext } from "../../../contexts";

const Heading = props => {
    // Destructured props
    const {title} = props;

    const {accessibilityFont} = useAppContext();

    const {highContrast} = useAppContext();

    return (
        <Fragment>
            <div className={s.root}>
                <h1 
                    className={`${s.heading} ${highContrast ? "highTitleFirst" : ""}`}
                    style={{
                        fontSize: window.innerWidth > 768 
                        ? `${30+accessibilityFont}px` 
                        : `${16+accessibilityFont}px`
                    }}
                >
                    {title}
                </h1>
            </div>
        </Fragment>
    )
}

export default Heading;
